import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { CustomResponseDto } from '@core/model/custom-response-dto';
import { CityRegionDto } from '@core/model/city-region-dto';
import { LatLngDto } from '@core/model/lat-lng-dto';
import { Region } from '@core/model/region';

@Injectable()
export class GeoInfoService {
  private apiUrl = environment.apiUrl;
  private googleUrl = `${this.apiUrl}origination/geo/current`;
  private ipDataUrl = `${this.apiUrl}origination/geo/current-ip-data`;
  private cityRegionUrl = `${this.apiUrl}origination/geo/get-city-and-region-by-ip`;

  private headers = getHttpHeaders();

  public constructor(private http: HttpClient) {}

  public getCityAndRegion(): Observable<CityRegionDto> {
    return this.http.get<CustomResponseDto<CityRegionDto>>(this.cityRegionUrl).pipe(
      map((response: CustomResponseDto<CityRegionDto>) => {
        if (response) {
          return response.response;
        }
      })
    );
  }
}
